<template>
<div class="x_box A4">
    <div class="x_body">
        <ReportHeader></ReportHeader>
        <div style="height: 2px; border: 1px solid black; width: 100%; background: black; margin-bottom: 20px"></div>
        <div class="card f_card">
            <div class="card-body">
                <h3 class="text-center" style="font-weight: bold;">{{$t('sale_quotation')}}</h3>
                <div class="row">
                    <div class="col-sm-6">
                        <table class="table-print">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">Customer</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.CustomerName}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 100px;">Phone</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Phone}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-sm-6">
                        <table class="table-print" align="right">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">Quotation no</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Num}}</td>
                                </tr>
                                <tr>
                                    <td>Quotation date</td>
                                    <td>:</td>
                                    <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-bordered table-sm no-bor">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 50px;">ល.រ <br/>No</th>
                                    <th class="text-center">លេខកូដ <br/>Item code</th>
                                    <th class="text-center">
                                        បរិយាយ <br/>
                                        Description of Good
                                    </th>
                                    <th class="text-center" style="width: 100px;">ចំនួន<br/>Quantity</th>
                                    <!-- <th class="text-center" style="width: 100px;">ខ្នាតទំនិញ<br/>Uom</th> -->
                                    <th class="text-center" style="width: 100px;">តម្លែ<br/>Price</th>
                                    <th class="text-center" style="width: 100px;">តំលៃសរុប<br/>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.ItemCode}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <!-- <td class="text-center">{{ret.UomName}}</td> -->
                                    <td class="text-right">{{$money(ret.Price)}}</td>
                                    <td class="text-right">{{$money(ret.SubTotal)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="5" class="text-right">សរុប / Total:</th>
                                    <th class="text-right">{{$money(invoice.TotalAmount)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import ReportHeader from '../Components/ReportHeader';
    export default {
        components: { ReportHeader },
        data: function(){
            return {
                company: {},
                invoice: {},
                lines: []
            }
        },
        created: function(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                this.$api().post('quote/preview', { Id: id, CompanyId: this.$store.state.company.Id }).then(res => {
                    var data = res.data.Json;
                    this.invoice = data.Header;
                    this.lines = data.Lines;
                }).finally(function(){ loading.hide(); });
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
</style>
